//接受单个url或者url array，异步加载资源
export function loadScript(url: string, callback: any): boolean | void {
  let urls: string[] = [],
    newUrl: string | undefined = "";
  if (typeof url === "object") {
    newUrl = (url as string[]).shift();
    urls = url;
  } else {
    newUrl = url;
  }
  if (!newUrl) {
    return false;
  }
  const script = document.createElement("script") as any
  script.type = "text/javascript";
  if (script.readyState as any) { //IE
    script.onreadystatechange = function () {
      if (script.readyState == "loaded" ||
        script.readyState == "complete") {
        script.onreadystatechange = null;
        if (urls.length == 0) {
          callback();
        } else {
          loadScript(urls as any, callback);
        }
      }
    };
  } else { //Others
    script.onload = function () {
      if (urls.length == 0) {
        callback();
      } else {
        loadScript(urls as any, callback);
      }
    };
  }
  script.src = newUrl;
  document.getElementsByTagName("head")[0].appendChild(script);
}